import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import NavigationElements from '../components/pageElements/NavigationElements';
import FooterElement from '../components/pageElements/FooterElement';
import { formattedCountryData, formattedGenderData, formattedBloodData } from '../common/utils/formattedData';
import SuccessModal from '../common/components/customSuccessModal/CustomSuccessModal';
import ErrorModal from '../common/components/customRedAlert/CustomRedAlert';
// import InputMask from 'comigo-tech-react-input-mask';
import InputMask from 'react-input-mask';
import useUserStore from '../zustand/fcmToken';
import axios from 'axios';
import FormInputField from '../common/components/formElements/FormInputField';
import { Tooltip } from 'react-tooltip';
import { z } from 'zod';
import { useForm, Controller } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import FormSelectDrop from '../common/components/formElements/FormSelectDrop';
import FormTextArea from '../common/components/formElements/FormTextArea';
import { Country, State } from 'country-state-city';
import PhoneInput from 'react-phone-input-2';

const date = new Date();
const MIN_AGE = 18;
const MAX_DATE = new Date(date.setFullYear(date.getFullYear() - MIN_AGE)).toJSON().slice(0, 10);
const defaultNationalityOpt = {
    id: 'default',
    label: 'Selecciona nacionalidad',
    value: 'Selecciona nacionalidad',
    disabled: true
};
const API_SERVER = process.env.REACT_APP_API_SERVER;

export default function SignUpPage(props) {
    const fcmToken = useUserStore((state) => state.fcmToken);
    const { displayNavigation, onUpdateDisplayNavigation, userType = 'patient' } = props;
    const [documentTypes, setDocumentTypes] = useState(null);
    const navigate = useNavigate();
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorBody, setErrorBody] = useState('');
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState('1');
    const [subList, setSubList] = useState([]);
    const [showPassword, setShowPassword] = useState({
        password: false,
        confirm_password: false
    });
    const [showSubFields, setShowSubFields] = useState(false);
    const [diseases, setDiseases] = useState([{ name: '' }]);

    const [diseaseErrors, setDiseaseErrors] = useState(['']);
    const [address, setAddress] = useState([{ address: '' }]);
    const [addressError, setAddressError] = useState(['']);
    const [countryCode, setCountryCode] = useState('91');
    const [phone, setPhone] = useState('');

    const onPhoneChange = (value, countryData, e, formattedValue) => {
        // Extract only the national number (remove country dial code)
        const nationalNumber = value.replace(countryData.dialCode, '').replace(/^0+/, '');

        setCountryCode(countryData.dialCode);
        setPhone(nationalNumber);
        setValue('countryCode', countryData.dialCode);
        setValue('phone', nationalNumber);
    };

    useEffect(() => {
        fetch('https://ipapi.co/json/')
            .then((res) => res.json())
            .then((data) => {
                const userCountryCode = data.country_calling_code.replace('+', '');
                setCountryCode(userCountryCode);
                setValue('countryCode', userCountryCode);

                if (userCountryCode !== countryCode) {
                    alert('El código del país no coincide con tu ubicación real.');
                }
            });
    }, []);

    const addDisease = () => {
        if (diseases.length < 5) {
            setDiseases([...diseases, { name: '' }]);
            setDiseaseErrors([...diseaseErrors, '']);
        }
    };
    const formSchema = (userType) => {
        const passwordRequirements = z
            .string()
            .min(8, 'Contraseña debe tener más de 8 caracteres')
            .regex(/[A-Z]/, 'Contraseña debe tener al menos una letra mayúscula');
        // .regex(/[!@#$%^&*(),.?":{}|<>]/, 'Password must have at least one special character');

        const baseSchema = {
            firstName: z
                .string()
                .min(1, 'Nombre es requerido')
                .max(100, 'Nombre debe tener como máximo 100 caracteres'),
            lastName: z.string().min(1, 'Apellido es requerido').max(100, 'Apellido debe tener como máximo 100 caracteres'),
            conademNumber: userType === 'doctor' ? z
                .string()
                .min(1, 'Número de autorización CONADEM es requerido')
                .regex(/^[a-zA-Z0-9]+$/, 'Sólo caracteres alfanuméricos permitidos')
                : z.string().optional(),
            // address: z.string().min(1, 'Address is required'),
            idDocumentTypes: z.string(),
            personalDocument: z.string().min(1, 'Número de documento es requerido'),
            birthDate: z.date({ required_error: 'Fecha de nacimiento es requerida', invalid_type_error: 'Fecha de nacimiento es requerida' }),
            phone: z
                .string()
                .min(1, 'Teléfono es requerido')
                .min(8, 'Número de teléfono debe tener al menos 8 dígitos')
                .regex(/^\d+$/, 'Teléfono solo debe contener dígitos'),
            countryCode: z.string().min(1, 'Código de país es requerido'),

            email: z.string().email('Correo electrónico inválido').min(1, 'Correo electrónico es requerido'),
            secondary_email: z.string().optional(),
            password: passwordRequirements,
            passwordConf: z.string().min(1, 'Confirmación de contraseña es requerida'),
            subscription: userType === 'doctor' ? z.string().min(1, 'Suscripción es requerida') : z.string().optional(),
            agreement: z.literal('true', { errorMap: () => ({ message: 'Debe aceptar los términos y condiciones' }) }),
            subDescription:
                userType === 'doctor'
                    ? z.string().min(1, 'Descripción de suscripción es requerida').max(100)
                    : z.string().optional(),
            subValue:
                userType === 'doctor'
                    ? z
                          .string()
                          .min(1, 'Valor de suscripción es requerido')
                          .regex(/^\$[0-9]+$/, 'Valor de suscripción debe ser un número')
                    : z.string().optional(),
            country: userType === 'patient' ? z.string().min(1, 'País es requerido') : z.string().optional(),
            state: userType === 'patient' ? z.string().min(1, 'Estado/residencia es requerido') : z.string().optional(),
            gender: userType === 'patient' ? z.string().min(1, 'Sexo es requerido') : z.string().optional(),
            // disease: z.string().optional(),
            allergies: z.string().optional(),
            blood_type: z.string().optional(),
            weight:
                userType === 'patient'
                    ? z
                          .string()
                          .min(1, 'Peso es requerido')
                          .regex(/^(?!0\d)\d*(\.\d+)?$/, 'Peso debe ser un número positivo')
                    : z.string().optional(),
            height:
                userType === 'patient'
                    ? z
                          .string()
                          .min(1, 'Estatura es requerida')
                          .regex(/^(?!0\d)\d*(\.\d+)?$/, 'Estatura debe ser un número positivo')
                    : z.string().optional()
        };

        const schema = z.object(baseSchema).superRefine((data, ctx) => {
            // Password match validation
            if (data.password !== data.passwordConf) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: 'Las contraseñas no coinciden',
                    path: ['passwordConf']
                });
            }

            // Document validation for doctors

            if (data.idDocumentTypes === '1' && data.personalDocument.length !== 10) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: 'Número de documento inválido',
                    path: ['personalDocument']
                });
            } else if (data.idDocumentTypes === '2' && data.personalDocument.length !== 9) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: 'Número de documento inválido',
                    path: ['personalDocument']
                });
            }
        });

        return schema;
    };

    const schema = formSchema(userType);
    const addAddress = () => {
        if (address.length < 3) {
            setAddress([...address, { address: '' }]);
            setAddressError([...addressError, '']);
        }
    };

    const removeAddress = (index) => {
        const newAddress = [...address];
        const newAddressError = [...addressError];
        newAddress.splice(index, 1);
        newAddressError.splice(index, 1);
        setAddress(newAddress);
        setAddressError(newAddressError);
    };
    // Now you can use `schema` to validate your form data

    const { register, handleSubmit, formState, watch, control, getValues, setValue, reset, trigger } = useForm({
        resolver: zodResolver(schema),
        mode: 'onTouched',
        reValidateMode: 'onChange',
        shouldFocusError: false,
        defaultValues: {
            phone: '',
            countryCode: '',
            state: '',
            country: ''
        }
    });

    const onSubmit = async (e) => {
        e.preventDefault();
        
        // Validate diseases/addresses for patient/doctor before form validation
        let hasDiseaseOrAddressErrors = false;
        if (userType === 'patient') {
            if (!validateDiseases()) {
                setDiseaseErrors(
                    diseases.map((d) => (d.name.trim() === '' ? 'Este campo no puede estar vacío' : ''))
                );
                hasDiseaseOrAddressErrors = true;
            }
        }
        if (userType === 'doctor') {
            if (!validateAddress()) {
                setAddressError(
                    address.map((d) => (d.address.trim() === '' ? 'Este campo no puede estar vacío' : ''))
                );
                hasDiseaseOrAddressErrors = true;
            }
        }
        
        // Trigger validation on all fields to show all errors at once
        await trigger();
        
        // If diseases/addresses have errors, don't proceed with form submission
        if (hasDiseaseOrAddressErrors) {
            return;
        }
        
        // Then proceed with normal form submission (handleSubmit will validate again but show errors immediately)
        handleSubmit(onSignUp)(e);
    };
    const { errors, isSubmitting, isValid } = formState;

    const removeDisease = (index) => {
        const newDiseases = [...diseases];
        const newErrors = [...diseaseErrors];
        newDiseases.splice(index, 1);
        newErrors.splice(index, 1);
        setDiseases(newDiseases);
        setDiseaseErrors(newErrors);
    };

    const [countryOptions, setCountryOptions] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);

    const selectedCountry = watch('country');

    useEffect(() => {
        const countries = Country.getAllCountries().map((c) => ({
            label: c.name,
            value: c.isoCode
        }));

        setCountryOptions(countries);
    }, []);

    useEffect(() => {
        if (selectedCountry) {
            const states = State.getStatesOfCountry(selectedCountry).map((s) => ({
                label: s.name,
                value: s.isoCode
            }));
            setStateOptions(states);
            setValue('state', '');
        }
    }, [selectedCountry, setValue]);

    const getDocumentTypes = async () => {
        await axios
            .get(`${API_SERVER}/admin-setup/document-types`)
            .then((res) => {
                // const defaultDocument = res?.data?.find((doc) => doc?.documentName === 'DUI');
                // defaultDocument &&
                //   setSelectedDocument({
                //     ...defaultDocument,
                //     label: personalDocuments[defaultDocument.documentName] ?? defaultDocument.documentName,
                //     value: personalDocuments[defaultDocument.documentName] ?? defaultDocument.documentName
                //   });
                setDocumentTypes(res?.data);
            })
            .catch((error) => {
                console.error(error);
            });
    };
    const personalDocumentValidation = (value) => {
        if (selectedDocument.label === 'DUI') {
            return /^\d{8}-\d{1}$/i.test(value);
        }
        return true;
    };
    useEffect(() => {
        getDocumentTypes();
    }, []);
    const handleDiseaseChange = (e, index) => {
        const { value } = e.target;
        const newDiseases = [...diseases];
        const newErrors = [...diseaseErrors];
        newDiseases[index].name = value;
        newErrors[index] = value.trim() === '' ? 'Este campo no puede estar vacío' : '';
        setDiseases(newDiseases);
        setDiseaseErrors(newErrors);
    };
    const handleAddress = (e, index) => {
        const { value } = e.target;
        const newAddress = [...address];
        const newAddressError = [...addressError];

        newAddress[index].address = value;
        newAddressError[index] = value.trim() === '' ? 'Este campo no puede estar vacío' : '';

        setAddress(newAddress);
        setAddressError(newAddressError);
    };
    const validateDiseases = () => {
        const hasEmpty = diseases?.some((d) => d?.name?.trim() === '');
        return !hasEmpty;
    };
    const validateAddress = () => {
        const hasEmpty = address?.some((d) => d?.address?.trim() === '');
        return !hasEmpty;
    };
    // const onSignUp = async (data) => {

    //   if (userType === 'patient') delete data.subscription;

    //   if (selectedDocument) {
    //     const payload = { ...data,fcmTokens:[fcmToken], idDocumentTypes: Number(selectedDocument) };
    //     if (userType === 'doctor') {
    //       payload.nationality = 'El Salvador';
    //     }
    //     try {
    //       const endpoint = userType === 'patient' ? '/auth/signup' : '/doctor-data/signup';

    //       const response = await axios.post(`${API_SERVER}${endpoint}`, payload);
    //       setShowSuccessModal(true);
    //     } catch (error) {

    //       switch (error.message) {
    //         case 'EMAIL IN USE':
    //           userType === 'patient'
    //             ? setErrorBody(`Una cuenta con el correo electrónico ingresado ya existe, por favor intentar de nuevo con otro correo electrónico`)
    //             : setErrorBody(`El correo electrónico ingresado ya existe en las perfiles de doctores en nuestros registros de Doctolink`);
    //           break;
    //         default:
    //           setErrorBody('Error al crear una cuenta, verifique los datos ingresados e intente nuevamente');
    //           break;
    //       }
    //       setShowErrorModal(true);
    //     }
    //   }
    // };
    const onSignUp = async (data) => {
        if (userType === 'patient') delete data.subscription;

        if (selectedDocument) {
            // Validate diseases only for patient
            if (userType === 'patient') {
                if (!validateDiseases()) {
                    setDiseaseErrors(
                        diseases.map((d) => (d.name.trim() === '' ? 'Este campo no puede estar vacío' : ''))
                    );
                    return;
                }
            }
            if (userType === 'doctor') {
                if (!validateAddress()) {
                    setAddressError(
                        address.map((d) => (d.address.trim() === '' ? 'Este campo no puede estar vacío' : ''))
                    );
                    return;
                }
            }

            const formattedBirthDate = data.birthDate
                ? (() => {
                      const d = new Date(data.birthDate);
                      const year = d.getFullYear();
                      const month = String(d.getMonth() + 1).padStart(2, '0');
                      const day = String(d.getDate()).padStart(2, '0');
                      return `${year}-${month}-${day}`; // YYYY-MM-DD exact
                  })()
                : null;
            const formattedBirthDateUTC = formattedBirthDate ? `${formattedBirthDate}T00:00:00Z` : null;

            const payload = {
                ...data,
                birthDate: formattedBirthDateUTC,
                fcmTokens: [fcmToken],
                idDocumentTypes: Number(selectedDocument)
            };

            if (userType === 'doctor') {
                payload.nationality = 'El Salvador';
                payload.addresses = address;
            }

            if (userType === 'patient') {
                payload.diseases = diseases;
            }

            try {
                const endpoint = userType === 'patient' ? '/auth/signup' : '/doctor-data/signup';
                const response = await axios.post(`${API_SERVER}${endpoint}`, payload);
                setShowSuccessModal(true);
            } catch (error) {
                switch (error?.response?.data?.message) {
                    case 'EMAIL IN USE':
                        userType === 'patient'
                            ? setErrorBody(
                                  `Una cuenta con el correo electrónico ingresado ya existe, por favor intentar de nuevo con otro correo electrónico`
                              )
                            : setErrorBody(
                                  `El correo electrónico ingresado ya existe en las perfiles de doctores en nuestros registros de Doctolink`
                              );
                        break;
                    default:
                        setErrorBody('Error al crear una cuenta, verifique los datos ingresados e intente nuevamente');
                        break;
                }
                setShowErrorModal(true);
            }
        }
    };

    const onCloseSuccessModal = () => {
        setShowSuccessModal(false);
        // navigate('/sign-in');
    };
    const onCloseErrorModal = () => {
        setShowErrorModal(false);
        setErrorBody('');
        // userType = 'doctor' ? navigate('/sign-in-doctor') : null;
    };

    const profileTypeOptions = [
        { id: 'informational', label: 'Informational Only' },
        { id: 'withAppointment', label: 'Informational with Appointment' }
    ];

    const getSubList = async () => {
        try {
            const res = await axios.get(`${API_SERVER}/subscription/list`);
            let list = res?.data?.map((val) => ({
                label: val?.title,
                value: val?.title?.toLowerCase(),
                description: val?.description,
                price: val?.price
            }));
            setSubList(list);
        } catch (error) {}
    };

    useEffect(() => {
        getSubList();
    }, []);

    const showAndHidePassword = (type) => {
        if (type == 'password') {
            setShowPassword((prev) => ({ ...prev, password: !showPassword.password }));
        } else {
            setShowPassword((prev) => ({ ...prev, confirm_password: !showPassword.confirm_password }));
        }
    };

    const handleSubChange = (event) => {
        const selectedSubscription = subList.find((item) => item.value === event.target.value);

        if (selectedSubscription) {
            setValue('subDescription', selectedSubscription.description);
            setValue('subValue', '$' + selectedSubscription.price);
            setShowSubFields(true);
        } else {
            setValue('subDescription', '');
            setValue('subValue', '');
            setShowSubFields(false);
        }
    };
    const ErrMsg = ({ message }) => (message ? <p className="mt-2 text-sm text-red-700">{message}</p> : null);

    return (
        <NavigationElements displayNavigation={displayNavigation} onUpdateDisplayNavigation={onUpdateDisplayNavigation}>
            <div className="bg-dl-screen-lightblue p-20">
                {/* <div className='w-full pb-10 text-center'><Link to={'/'}> <img className='w-72 mx-auto' src={logo} alt='Workflow' /></Link></div> */}
                <div className="min-h-full grid grid-flow-col ">
                    <div className="col-span-12 md:col-span-8">
                        <form className=" space-y-6" onSubmit={onSubmit} noValidate>
                            <div className="rounded-2xl mt-0 mb-45">
                                <div className="bg-white rounded-[1rem]">
                                    <div className="form-heading-top rounded-[1rem_1rem_0_0]">
                                        <h3>Datos generales</h3>
                                    </div>
                                    <div className="grid grid-cols-6 gap-6 pt-[20px] px-[40px] pb-[30px]">
                                        <div className="col-span-6 sm:col-span-3">
                                            <FormInputField
                                                identifier="firstName"
                                                label="Nombre(s)"
                                                type="string"
                                                placeholder="Introduce tu nombre"
                                                registration={register('firstName')}
                                                errorMessage={errors.firstName?.message}
                                            />
                                        </div>
                                        {console.log("1111",errors)}
                                        <div className="col-span-6 sm:col-span-3">
                                            <FormInputField
                                                identifier="lastName"
                                                label="Apellido(s)"
                                                type="string"
                                                placeholder="Introduce tu apellido"
                                                registration={register('lastName')}
                                                errorMessage={errors.lastName?.message}
                                            />
                                        </div>
                                        {userType === 'doctor' && (
                                            <div className="col-span-6 sm:col-span-3">
                                                <FormInputField
                                                    identifier="conademNumber"
                                                    label="Número de autorización CONADEM"
                                                    type="text"
                                                    placeholder="Ingrese su número CONADEM"
                                                    registration={register('conademNumber')}
                                                    errorMessage={errors.conademNumber?.message}
                                                />
                                            </div>
                                        )}

                                        <div className="col-span-6 sm:col-span-3">
                                            <label className="block text-sm font-medium text-dl-accent mb-2 text-black">
                                                Teléfono
                                            </label>
                                            <div className="relative rounded-full w-full">
                                                <Controller
                                                    name="fullPhone"
                                                    control={control}
                                                    render={({ field: { onChange, value, ref } }) => {
                                                        const countryCodeVal = getValues('countryCode') || '';
                                                        const phoneVal = getValues('phone') || '';
                                                        const mergedValue = value || `${countryCodeVal}${phoneVal}`;

                                                        return (
                                                            <PhoneInput
                                                                country="sv"
                                                                value={mergedValue}
                                                                onChange={(val, country) => {
                                                                    const dialCode = `+${country.dialCode}`;
                                                                    const phoneNumber = val
                                                                        .replace(country.dialCode, '')
                                                                        .replace(/^\+/, '');

                                                                    setValue('countryCode', dialCode);
                                                                    setValue('phone', phoneNumber);
                                                                    trigger('phone'); // Trigger validation after setting phone value
                                                                    trigger('countryCode');

                                                                    onChange(val);
                                                                }}
                                                                countryCodeEditable={false}
                                                                disableAreaCodes
                                                                inputProps={{ 
                                                                    ref,
                                                                    required: false,
                                                                    'aria-required': false
                                                                }}
                                                            />
                                                        );
                                                    }}
                                                />

                                                {errors.phone && (
                                                    <span style={{ fontSize: '0.875rem', color: 'rgb(185 28 28)' }}>
                                                        {errors.phone.message}
                                                    </span>
                                                )}
                                                {errors.countryCode && (
                                                    <span style={{ fontSize: '0.875rem', color: 'rgb(185 28 28)' }}>
                                                        {errors.countryCode.message}
                                                    </span>
                                                )}
                                            </div>
                                        </div>

                                        {/* <div className="col-span-6 sm:col-span-4">
                                            <FormInputField
                                                identifier="phone"
                                                label="Teléfono"
                                                type="string"
                                                registration={register('phone')}
                                                errorMessage={errors.phone?.message}
                                            />
                                        </div> */}

                                        {userType === 'doctor' && (
                                            <>
                                                <div className="col-span-6">
                                                    <div className="space-y-4">
                                                        {address.map((add, index) => (
                                                            <div key={index} className="flex items-center gap-3">
                                                                <FormInputField
                                                                    identifier={`direccion_${index}`}
                                                                    label={`Direccion de clinica ${index + 1}`}
                                                                    type="string"
                                                                    value={add.address}
                                                                    onChange={(e) => handleAddress(e, index)}
                                                                    // registration={register('address')}
                                                                />

                                                                {addressError[index] && (
                                                                    <p className="text-red-700">
                                                                        {addressError[index]}
                                                                    </p>
                                                                )}

                                                                {address.length > 1 && (
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => removeAddress(index)}
                                                                        className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-red-100 hover:bg-red-200 text-red-600 text-xl font-bold transition"
                                                                        title="Eliminar"
                                                                    >
                                                                        &minus;
                                                                    </button>
                                                                )}
                                                            </div>
                                                        ))}

                                                        {address.length < 3 && (
                                                            <div>
                                                                <button
                                                                    type="button"
                                                                    onClick={addAddress}
                                                                    className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded shadow transition"
                                                                >
                                                                    <span className="text-lg leading-none">+</span>
                                                                    Añadir otra dirección
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </>
                                        )}

                                        {userType == 'patient' ? (
                                            <div className="col-span-6 sm:col-span-3">
                                                <label
                                                    htmlFor="country"
                                                    className="block text-sm font-medium text-gray-700"
                                                >
                                                    Seleccione País de residencia
                                                </label>
                                                <select
                                                    id="country"
                                                    {...register('country')}
                                                    required={false}
                                                    className="mt-1 block w-full bg-white border border-gray-300 rounded-full shadow-sm px-3 py-2 focus:outline-none focus:ring-dl-primary-500 focus:border-dl-primary-500 sm:text-sm"
                                                >
                                                    <option value="">-- Seleccionar País --</option>
                                                    {countryOptions.map((country) => (
                                                        <option key={country.value} value={country.value}>
                                                            {country.label}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.country && (
                                                    <p className="mt-2 text-sm text-red-700">
                                                        {errors.country.message}
                                                    </p>
                                                )}
                                            </div>
                                        ) : null}
                                        {/* add residence in selct option like country */}
                                        {userType === 'patient' && selectedCountry && (
                                            <div className="col-span-6 sm:col-span-3">
                                                <label
                                                    htmlFor="state"
                                                    className="block text-sm font-medium text-gray-700"
                                                >
                                                    Seleccione residencia
                                                </label>
                                                <select
                                                    id="state"
                                                    {...register('state')}
                                                    required={false}
                                                    className="mt-1 block w-full bg-white border border-gray-300 rounded-full shadow-sm px-3 py-2 focus:outline-none focus:ring-dl-primary-500 focus:border-dl-primary-500 sm:text-sm"
                                                >
                                                    <option value="">-- Seleccionar Estado/Residencia --</option>
                                                    {stateOptions.map((state) => (
                                                        <option key={state.value} value={state.value}>
                                                            {state.label}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.state && (
                                                    <p className="text-sm text-red-500 mt-1">{errors.state.message}</p>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="rounded-2xl overflow-hidden mt-0 mb-45">
                                <div className="bg-white">
                                    <div className="form-heading-top">
                                        <h3>Documentación</h3>
                                    </div>
                                    <div className="grid grid-cols-6 gap-6 pt-[20px] px-[40px] pb-[30px]">
                                        {documentTypes?.length > 0 && selectedDocument !== null ? (
                                            <>
                                                <div className="col-span-4 sm:col-span-2">
                                                    <label
                                                        htmlFor={'idDocumentTypes'}
                                                        className="block font-medium text-sm text-black"
                                                    >
                                                        Tipo de documento de identidad
                                                    </label>
                                                    <select
                                                        {...register('idDocumentTypes')}
                                                        onChange={(e) => {
                                                            setSelectedDocument(e.target.value);
                                                            reset({ personalDocument: '' });
                                                        }}
                                                        className="mt-1 block w-full bg-white border border-gray-300 rounded-full shadow-sm px-3 focus:outline-none focus:ring-dl-primary-500 focus:border-dl-primary-500 sm:text-sm font-normal	"
                                                    >
                                                        {documentTypes.map((item) => (
                                                            <option
                                                                className="bg-white text-black"
                                                                key={item.id}
                                                                value={item.id}
                                                            >
                                                                {item.documentName}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                {/* <div className="col-span-4 sm:col-span-2">
                          <Controller
                            control={control}
                            name="idDocumentTypes"
                            defaultValue={selectedDocument}
                            value={selectedDocument}
                            render={({ field }) => (
                              <FormComboBox
                                label="Tipo de documento de identidad"
                                data={documentTypes.map((doc) => ({ ...doc, label: personalDocuments[doc.documentName] ?? doc.documentName, value: personalDocuments[doc.documentName] ?? doc.documentName }))}
                                value={field.value}
                                onChange={(value) => {
                                  console.log(value);
                                  field.onChange(value);
                                  setSelectedDocument(value);
                                }}
                              />
                            )}
                          />
                        </div> */}
                                                <div className="col-span-8 sm:col-span-4">
                                                    {/* <div className='flex flex-row gap-1.5'> */}
                                                    <label class="block text-sm font-medium text-gray-700">
                                                        Numero de documento
                                                    </label>
                                                    {/* <InputMask
                            identifier="personalDocument"
                            type="text"
                            name="personal-document"
                            id="personal-document"
                            autoComplete="family-name"
                            label="Numero de documento"
                            className="mt-1 block w-full border border-gray-300 rounded-full shadow-sm py-2 px-3 focus:outline-none focus:ring-dl-primary-700 focus:border-dl-primary-700 sm:text-sm"
                            mask={selectedDocument === '1' ? '99999999-9' : '*********'}
                            {...register('personalDocument')}
                          /> */}
                                                    <InputMask
                                                        name="personal-document"
                                                        id="personal-document"
                                                        mask={selectedDocument === '1' ? '99999999-9' : '*********'}
                                                        maskChar={null}
                                                        placeholder={
                                                            selectedDocument === '1'
                                                                ? '12345678-9'
                                                                : 'Ingrese documento'
                                                        }
                                                        className="mt-1 block w-full border border-gray-300 rounded-full shadow-sm py-2 px-3 focus:outline-none focus:ring-dl-primary-700 focus:border-dl-primary-700 sm:text-sm"
                                                        {...register('personalDocument')}
                                                    />
                                                    {errors?.personalDocument ? (
                                                        <p className="mt-2 text-sm text-red-700">
                                                            {errors?.personalDocument?.message}
                                                        </p>
                                                    ) : null}
                                                </div>
                                            </>
                                        ) : null}
                                        {/* </div> */}
                                        {/* <FormComboBox label='Tipo de documento de identidad' data={[defaultNationalityOpt, ...formattedCountryData]} value={field.value} onChange={(value) => field.onChange(value)} />
                      <FormInputField identifier="idDocumentTypes" label="Tipo de documento de identidad" type="string" registration={register('idDocumentTypes')} errorMessage={errors.idDocumentTypes?.message} /> */}

                                        {/* <div className="col-span-6 sm:col-span-2">
                      <FormInputField identifier="personalDocument" label="Numero de documento" type="string" registration={register('personalDocument')} errorMessage={errors.personalDocument?.message} />
                    </div> */}
                                        <div className="col-span-6 signup_datepicker">
                                            <label
                                                htmlFor="birthdate"
                                                className="block text-sm font-medium text-dl-accent"
                                            >
                                                <span className="block text-sm font-medium text-gray-700">
                                                    Fecha de nacimiento
                                                </span>
                                            </label>
                                            <Controller
                                                control={control}
                                                name="birthDate"
                                                // registration={{...register('birthDate')}}
                                                render={({ field }) => (
                                                    <DatePicker
                                                        selected={field.value}
                                                        dateFormat="dd/MM/yyyy"
                                                        onChange={(date) => field.onChange(date)}
                                                        onKeyDown={(e) => {
                                                            e.preventDefault();
                                                        }}
                                                        maxDate={new Date(MAX_DATE)}
                                                        dateFormatCalendar="MMMM"
                                                        peekNextMonth
                                                        dropdownMode="select"
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        showFullMonthYearPicker={true}
                                                        placeholderText="DD/MM/AAAA"
                                                        className="mt-1 block w-full border border-gray-300 rounded-full shadow-sm py-2 px-3 focus:outline-none focus:ring-dl-primary-700 focus:border-dl-primary-700 sm:text-sm"
                                                    />
                                                )}
                                            />
                                            {errors.birthDate ? (
                                                <p className="mt-2 text-sm text-red-700">{errors.birthDate?.message}</p>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {userType == 'patient' ? (
                                <div className="rounded-2xl overflow-hidden mt-0 mb-45">
                                    <div className="bg-white">
                                        <div className="form-heading-top">
                                            <h3>Información complementaria</h3>
                                        </div>
                                        <div className="grid grid-cols-6 gap-6 pt-[20px] px-[40px] pb-[30px]">
                                            {userType === 'patient' && (
                                                <>
                                                    <div className="col-span-6">
                                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                                            Enfermedades (máx. 5)
                                                        </label>
                                                        <div className="space-y-4">
                                                            {diseases.map((disease, index) => (
                                                                <div key={index} className="mb-3">
                                                                    <input
                                                                        type="text"
                                                                        value={disease.name}
                                                                        onChange={(e) => handleDiseaseChange(e, index)}
                                                                        placeholder="Nombre de la enfermedad"
                                                                        className="w-full border border-gray-300 rounded-md p-2"
                                                                    />
                                                                    <ErrMsg message={diseaseErrors[index]} />
                                                                    {index > 0 && (
                                                                        <button
                                                                            type="button"
                                                                            onClick={() => removeDisease(index)}
                                                                            className="text-red-600 text-sm mt-1"
                                                                        >
                                                                            Eliminar
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            ))}
                                                            {diseases.length < 5 && (
                                                                <button
                                                                    type="button"
                                                                    onClick={addDisease}
                                                                    className="text-blue-600 text-sm mt-2"
                                                                >
                                                                    + Añadir otra Enfermedades
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                            <div className="col-span-6 sm:col-span-3">
                                                <FormSelectDrop
                                                    identifier="gender"
                                                    label="Sexo"
                                                    registration={register('gender')}
                                                    options={formattedGenderData}
                                                    errorMessage={errors.gender?.message}
                                                    className="mt-1 block w-full bg-white border border-gray-300 rounded-full shadow-sm px-3 focus:outline-none focus:ring-dl-primary-500 focus:border-dl-primary-500 sm:text-sm font-normal	"
                                                />
                                            </div>
                                            <div className="col-span-6 sm:col-span-3">
                                                <FormInputField
                                                    identifier="disease"
                                                    label="¿Padece de alguna enfermedad? (Especifique cual)"
                                                    type="string"
                                                    placeholder="Ej. Asma, diabetes, etc."
                                                    registration={register('disease')}
                                                    errorMessage={errors.disease?.message}
                                                />
                                            </div>
                                            <div className="col-span-6 sm:col-span-3">
                                                <FormInputField
                                                    identifier="allergies"
                                                    label="¿Padece de alguna alergia? (Especifique cual)"
                                                    type="string"
                                                    placeholder="Ej. Polen, maní, medicamentos, etc."
                                                    registration={register('allergies')}
                                                    errorMessage={errors.allergies?.message}
                                                />
                                            </div>
                                            <div className="col-span-6 sm:col-span-3">
                                                <FormSelectDrop
                                                    identifier="blood_type"
                                                    label="Tipo de sangre"
                                                    registration={register('blood_type')}
                                                    options={formattedBloodData}
                                                    className="mt-1 block w-full bg-white border border-gray-300 rounded-full shadow-sm px-3 focus:outline-none focus:ring-dl-primary-500 focus:border-dl-primary-500 sm:text-sm font-normal	"
                                                />
                                            </div>
                                            <div className="col-span-6 sm:col-span-3">
                                                <FormInputField
                                                    identifier="weight"
                                                    label="Peso"
                                                    type="string"
                                                    placeholder="Peso en Lb"
                                                    registration={register('weight', {
                                                        onChange: (e) => {
                                                            const value = e.target.value;
                                                            if (!/^(?!0\d)\d*(\.\d+)?$/.test(value)) {
                                                                e.target.value = value.replace(/[^0-9.]/g, '');
                                                            }
                                                        }
                                                    })}
                                                    errorMessage={errors.weight?.message}
                                                />
                                            </div>
                                            <div className="col-span-6 sm:col-span-3">
                                                <FormInputField
                                                    identifier="height"
                                                    label="Estatura"
                                                    type="string"
                                                    placeholder="Altura en cm"
                                                    registration={register('height', {
                                                        onChange: (e) => {
                                                            const value = e.target.value;
                                                            if (!/^(?!0\d)\d*(\.\d+)?$/.test(value)) {
                                                                e.target.value = value.replace(/[^0-9.]/g, '');
                                                            }
                                                        }
                                                    })}
                                                    errorMessage={errors.height?.message}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                            <div className="rounded-2xl overflow-hidden mt-0 mb-45">
                                <div className="bg-white">
                                    <div className="form-heading-top">
                                        <h3>Cuenta</h3>
                                    </div>
                                    <div className="grid grid-cols-6 gap-6 pt-[20px] px-[40px] pb-[30px]">
                                        <div className="col-span-6 sm:col-span-3">
                                            <FormInputField
                                                identifier="email"
                                                label="Correo"
                                                type="string"
                                                placeholder="Ej. usuario@correo.com"
                                                registration={register('email')}
                                                errorMessage={errors.email?.message}
                                            />
                                        </div>
                                        {userType === 'doctor' && (
                                            <div className="col-span-6 sm:col-span-3">
                                                <FormInputField
                                                    identifier="secondary_email"
                                                    label="Correo electrónico secundario"
                                                    type="string"
                                                    placeholder="Ej. secundario@correo.com"
                                                    registration={register('secondary_email')}
                                                    errorMessage={errors.secondary_email?.message}
                                                />
                                            </div>
                                        )}
                                        <div className="col-span-6 sm:col-span-3 ">
                                            {/* <FormInputField identifier="password" label="Contraseña" type="password" registration={register('password')} errorMessage={errors.password?.message} /> */}
                                            <div className="flex flex-row items-center mb-2 gap-2">
                                                <label
                                                    htmlFor={'password'}
                                                    className=" text-sm font-medium text-dl-accent  text-sm text-black"
                                                >
                                                    Contraseña
                                                </label>

                                                <span>
                                                    <a className="my-anchor-element">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            strokeWidth={1.5}
                                                            stroke="currentColor"
                                                            className="size-5"
                                                        >
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z"
                                                            />
                                                        </svg>
                                                    </a>
                                                    <Tooltip anchorSelect=".my-anchor-element" place="top">
                                                        Contraseña debe tener al menos 8 caracteres, <br /> 1 letra mayúscula,
                                                        y 1 carácter especial.
                                                    </Tooltip>
                                                </span>
                                            </div>

                                            <div className="relative rounded-md ">
                                                <input
                                                    type={showPassword.password ? 'text' : 'password'}
                                                    name={'password'}
                                                    id={'password'}
                                                    placeholder="Ingrese su contraseña"
                                                    className={` block w-full border border-gray-300 rounded-full  py-2 px-3 focus:outline-none focus:ring-dl-primary-400 focus:border-dl-primary-400 sm:text-sm font-normal h-10	 `}
                                                    {...register('password')}
                                                />
                                                <span className="absolute top-2 right-3">
                                                    {showPassword.password ? (
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            strokeWidth={1.5}
                                                            stroke="currentColor"
                                                            className="size-6 cursor-pointer"
                                                            onClick={() => showAndHidePassword('password')}
                                                        >
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                                                            />
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                                                            />
                                                        </svg>
                                                    ) : (
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            strokeWidth={1.5}
                                                            stroke="currentColor"
                                                            className="size-6 cursor-pointer"
                                                            onClick={() => showAndHidePassword('password')}
                                                        >
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
                                                            />
                                                        </svg>
                                                    )}
                                                </span>
                                            </div>
                                            {errors.password?.message ? (
                                                <p className="mt-2 text-sm text-red-700">{errors.password?.message}</p>
                                            ) : null}
                                        </div>
                                        {/* <div className="col-span-6 sm:col-span-3">
                      <FormInputField identifier="passwordConf" label="Confirmar contraseña" type="password" registration={register('passwordConf')} errorMessage={errors.passwordConf?.message} />
                    </div> */}

                                        <div className="col-span-6 sm:col-span-3 ">
                                            <label
                                                htmlFor={'passwordConf'}
                                                className="block text-sm font-medium text-dl-accent mb-2 text-sm text-black"
                                            >
                                                Confirmar Contraseña
                                            </label>

                                            <div className="relative rounded-md ">
                                                <input
                                                    type={showPassword.confirm_password ? 'text' : 'password'}
                                                    name={'passwordConf'}
                                                    placeholder="Confirmar contraseña"
                                                    id={'passwordConf'}
                                                    className={` block w-full border border-gray-300 rounded-full  py-2 px-3 focus:outline-none focus:ring-dl-primary-400 focus:border-dl-primary-400 sm:text-sm font-normal h-10	 `}
                                                    {...register('passwordConf')}
                                                />
                                                <span className="absolute top-2 right-3">
                                                    {showPassword.confirm_password ? (
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            strokeWidth={1.5}
                                                            stroke="currentColor"
                                                            className="size-6 cursor-pointer"
                                                            onClick={() => showAndHidePassword('confirm_password')}
                                                        >
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                                                            />
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                                                            />
                                                        </svg>
                                                    ) : (
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            strokeWidth={1.5}
                                                            stroke="currentColor"
                                                            className="size-6 cursor-pointer"
                                                            onClick={() => showAndHidePassword('confirm_password')}
                                                        >
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
                                                            />
                                                        </svg>
                                                    )}
                                                </span>
                                            </div>
                                            {errors.passwordConf?.message ? (
                                                <p className="mt-2 text-sm text-red-700">
                                                    {errors.passwordConf?.message}
                                                </p>
                                            ) : null}
                                        </div>

                                        {userType === 'doctor' ? (
                                            <div className="col-span-6 sm:col-span-3">
                                                <>
                                                    <div className="flex flex-row items-center mb-2 gap-2">
                                                        <label
                                                            htmlFor="subscription"
                                                            className="block text-sm font-medium text-dl-accent text-sm text-black"
                                                        >
                                                            Suscripción
                                                        </label>
                                                        <a className="subscription">
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                fill="none"
                                                                viewBox="0 0 24 24"
                                                                strokeWidth={1.5}
                                                                stroke="currentColor"
                                                                className="size-5"
                                                            >
                                                                <path
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                    d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z"
                                                                />
                                                            </svg>
                                                        </a>
                                                        <Tooltip anchorSelect=".subscription" place="top">
                                                            Lite : Sólo se permite visualización de perfil del doctor e
                                                            información general <br />
                                                            Pro : Permite visualización del perfil e información general
                                                            + el poder agendar citas, contar con un calendario y carga
                                                            de documentos a los pacientes.
                                                        </Tooltip>
                                                    </div>
                                                    <select
                                                        id={'subscription'}
                                                        name={'subscription'}
                                                        onInput={(event) => handleSubChange(event)}
                                                        {...register('subscription')}
                                                        className="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-dl-primary-500 focus:border-dl-primary-500 sm:text-sm"
                                                    >
                                                        <option key="empty-select-value" value="">
                                                            --- Seleccione --
                                                        </option>
                                                        {subList?.map((opt) => {
                                                            return (
                                                                <option key={opt.label} value={opt.value}>
                                                                    {opt.label}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>

                                                    {errors.subscription ? (
                                                        <p className="mt-2 text-sm text-red-700">
                                                            {errors.subscription?.message}
                                                        </p>
                                                    ) : null}
                                                </>
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                        {/* <div className="col-span-3"></div> */}
                                        {showSubFields ? (
                                            <>
                                                <div className="col-span-3">
                                                    <FormTextArea
                                                        identifier="subDescription"
                                                        label="Descripción de suscripción"
                                                        type="string"
                                                        disabled={true}
                                                        registration={register('subDescription')}
                                                        errorMessage={errors.subDescription?.message}
                                                    />
                                                </div>
                                                <div className="col-span-3">
                                                    <FormInputField
                                                        identifier="subValue"
                                                        label="Valor de suscripción"
                                                        type="string"
                                                        disabled={true}
                                                        registration={register('subValue')}
                                                        errorMessage={errors.subValue?.message}
                                                    />
                                                </div>
                                            </>
                                        ) : null}
                                    </div>
                                </div>
                            </div>

                            <fieldset className="col-span-12 main-bottom-box">
                                <div className="mt-4 space-y-4">
                                    <div className="flex items-center justify-center">
                                        <div className="h-5 flex items-center">
                                            <input
                                                id="agreement"
                                                name="agreement"
                                                type="checkbox"
                                                value={true}
                                                className="focus:ring-dl-green h-4 w-4 text-dl-green border-gray-300 rounded"
                                                {...register('agreement')}
                                            />
                                        </div>
                                        <div className="ml-3 text-sm">
                                            <label htmlFor="agreement" className="font-medium text-dl-accent">
                                                Acepto &nbsp;
                                                <a
                                                    href=""
                                                    className="text-dl-primary-800 hover:text-dl-primary-700 check-text font-bold"
                                                >
                                                    Terminos y condiciones de DoctoLink
                                                </a>
                                            </label>
                                        </div>
                                    </div>
                                    {errors.agreement ? (
                                        <div class="flex items-center justify-center">
                                            <p className="text-red-700 font-light ">{errors.agreement?.message}</p>
                                        </div>
                                    ) : null}
                                </div>
                            </fieldset>
                            <div className="btn-form mt-5">
                                <button
                                    type="submit"
                                    className="btn-primary btn-md btn-sm  m-auto select-none"
                                    disabled={isSubmitting}
                                >
                                    Crear usuario
                                </button>
                            </div>

                            {/* <p className='text-center'>or</p>
              <br /> */}
                            {/* <div className='flex justify-center gap-6' >
                <LoginSocialGoogle
                  scope="openid profile email"
                  client_id={process.env.REACT_APP_GG_APP_ID || ''}
                  onResolve={({ provider, data }) => {
                    setValue("email", data?.email)
                    setValue("firstName", data?.given_name)
                    setValue("lastName", data?.family_name)
                  }}
                  onReject={(err) => {
                    console.log(err)
                  }}
                >
                  <img src='/defaultIcons/google.png' className='h-[30px] cursor-pointer' />
                </LoginSocialGoogle>


                <LoginSocialFacebook
                  appId={process.env.REACT_APP_FB_APP_ID}
                  fieldsProfile={"id,first_name,last_name,middle_name,name,name_format,picture,short_name,email,gender"}
                  onResolve={({ provider, data }) => {
                    setValue("email", data?.email)
                    setValue("firstName", data?.first_name)
                    setValue("lastName", data?.last_name)
                  }}
                  onReject={(err) => {
                    console.log(err)
                  }}
                >
                  <img src='/defaultIcons/facebook.png' className='h-[30px] cursor-pointer' />
                </LoginSocialFacebook>
                <LoginSocialApple
                  client_id={process.env.REACT_APP_APPLE_ID}
                  redirect_uri={window.location.href || ''}
                  scope="email name"
                  onResolve={({ provider, data }) => {
                    const result = jwtDecode(data.authorization.id_token);
                    setValue("email", result?.email);
                    setValue("firstName", data?.name?.firstName)
                    setValue("lastName", data?.name?.lastName)
                  }}
                  onReject={(err) => {
                    console.log(err)
                  }}
                >
                  <img src='/defaultIcons/apple.png' className='h-[30px] cursor-pointer' />
                </LoginSocialApple>
              </div> */}
                        </form>
                    </div>
                </div>
            </div>

            {/* popup modal */}
            {/* Revisa tu correo electrónico para verificar tu cuenta. */}
            <SuccessModal
                title="Cuenta creada exitosamente"
                // bodyText="Se ha enviado un correo electrónico para confirmar su cuenta"
                bodyText="Se ha enviado un correo electrónico para confirmar su cuenta. Haga clic en el enlace de su correo electrónico para verificar su cuenta."
                buttonText="Finalizar"
                buttonAction={() => navigate(`/sign-in${userType === 'doctor' ? '-doctor' : ''}`)}
                open={showSuccessModal}
                onClose={onCloseSuccessModal}
            />
            <ErrorModal
                title="Error al crear cuenta"
                bodyText={errorBody}
                mainActionText="Cerrar"
                onMainAction={onCloseErrorModal}
                open={showErrorModal}
                onClose={onCloseErrorModal}
            />
            {/* Footer */}
            <FooterElement />
        </NavigationElements>
    );
}
